// extracted by mini-css-extract-plugin
module.exports = {"topics":"TopicsButton_topics__Lo8q9"};